import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Chip,
  Box,
} from "@mui/material";
import { getIcingName } from "./utils";

const DetailsModal = ({ open, onClose, cake, icingOptions, flavorOptions }) => {
  const renderInsideIcing = () => (
    <Box>
      {cake.flavors.map((flavorId, index) => {
        const flavor = flavorOptions.find((f) => f._id === flavorId._id);
        const icing = icingOptions.find((i) => i._id === flavor?.icing?._id);
        return (
          <Typography key={index} variant="body2">
            {icing?.name || "Unknown Icing"}
          </Typography>
        );
      })}
    </Box>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cake Details</DialogTitle>
      <DialogContent>
        <Typography variant="h6">Searchable Description</Typography>
        <Typography variant="body2">
          {cake.searchableDescription || "N/A"}
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          Popularity
        </Typography>
        <Typography variant="body2">{cake.popularity}</Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          SEO Meta Title
        </Typography>
        <Typography variant="body2">{cake.seo?.metaTitle || "N/A"}</Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          SEO Meta Description
        </Typography>
        <Typography variant="body2">
          {cake.seo?.metaDescription || "N/A"}
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          SEO Meta Keywords
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {cake.seo?.metaKeywords?.length > 0
            ? cake.seo.metaKeywords.map((keyword, i) => (
                <Chip key={i} label={keyword} />
              ))
            : "N/A"}
        </Box>

        <Typography variant="h6" sx={{ mt: 2 }}>
          Inside Icing
        </Typography>
        {renderInsideIcing()}

        <Typography variant="h6" sx={{ mt: 2 }}>
          Outside Icing
        </Typography>
        <Typography variant="body2">
          {getIcingName(cake.outsideIcing, icingOptions)}
        </Typography>
        <Typography variant="h6" sx={{ mt: 2 }}>
          Colors
        </Typography>
        {cake.colors?.length > 0 ? (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {cake.colors.map((color, index) => (
              <Chip key={index} label={color} />
            ))}
          </Box>
        ) : (
          <Typography variant="body2">N/A</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailsModal;
